import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { TitleCasePipe } from '@angular/common';
import { SubService } from 'src/app/Services/sub.service';
import { SubjectService } from 'src/app/Services/subject-services';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'app-new-roster-trip-counts',
  templateUrl: './new-roster-trip-counts.component.html',
  styleUrls: ['./new-roster-trip-counts.component.css'],
  providers: [TitleCasePipe]
})

export class NewRosterTripCountsComponent implements OnInit {

  public formFilters: any = FormGroup;
  startDateError: boolean;
  public excelData = {};
  public enableAllOption: boolean = true;
  public multiSelectVehicle: boolean = false;
  public allVehDownload: boolean;
  public tableData = [];
  public cols = [
    { key: '#', display: '#' },
    { key: 'DateTime', display: 'Date / Time', headerConfig: { isDefault: true } },
    { key: 'Location', display: 'Location' },
    { key: 'Speed', display: 'Speed (km/h)', headerConfig: { isDefault: true } },

  ];

  public noDataFoundEnable: boolean = false;

  public processedData: any = {};
  public objectKeys = Object.keys;
  public totalDistance: any = 0;
  public myDate = new Date();
  public maxDate: any;
  isAssigned: boolean;
  formData: any;
  report_type: string = 'vehicle';
  checkDay: boolean;
  public emplHeaders = [
    '#', 'Trip date', 'Reg no', 'Shift time', 'Transit mode', 'Employee name', 'Employee ID', 'Attendance',
  ]
  public tableHeaders = [];
  public driverTabheaders = [
    '#', 'Trip date', 'Reg no', 'Shift time', 'Transit mode', 'Driver name', 'Driver mobile', 'Distance travel (km)', 'Traveled duration (HH:MM:SS) ', 'Route type / Status'
  ]
  // 'Max speed (km/h)'
  employeeTableData: any = [];
  vehicleTableData: any = [];
  empTableShow: boolean = false;
  vehTableShow: boolean = false;
  public loadershow:boolean=false;

  constructor(
    public fb: FormBuilder,
    public comService: CommonServices,
    public api: ApiService,
    public loader: LoaderService,
    public excel: ExcelExportService,
    public com: CommonServices,
    public sub:SubService,
    public titleCasePipe: TitleCasePipe,
     public storage: StorageService,
    private subject: SubjectService
  ) {
     this.storage.setData({report_submit:false})
    this.maxDate = new Date(
      this.myDate.getFullYear(),
      this.myDate.getMonth(),
      this.myDate.getDate() - 1
    );
    this.getVehicleDetails();
   // if (this.report_type == "employee") this.tableHeaders = this.emplHeaders;
    if (this.report_type == "vehicle") this.tableHeaders = this.driverTabheaders;
  }

  public showTable: boolean = false;
  public vehicleRegNos: any
  public vehicles = [];

  async getVehicleEncryptRegNo(regNo) {
    return new Promise((resolve, rejects) => {
      this.api.getVehicleRegNo({ vehRegNo: regNo }).then((res) => {
        if (res['status'] == 'success') resolve(res['data']);
        else rejects(res['data'])
      })
    })
  }

  getVehicleDetails() {

    const obj = {
      orgID: localStorage.orgID,//this.orgID == null ? this.storage.get('vendorID_orgID').orgID : this.orgID,
      vendorID: localStorage.vendorID //this.vendorID == null ? this.storage.get('vendorID_orgID').vendorID : this.vendorID,
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehicles = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });

  }

  ngOnInit(): void {
     this.storage.setData({report_submit:false});
    this.reactiveForm();

  }

  reactiveForm() {
    this.formFilters = this.fb.group({
      selectedVehicle: ['', Validators.required],
      sDate: ['', Validators.required],
      eDate: ['', Validators.required],
    }, {
      validator: [this.comService.formToDateValidation('sDate', 'eDate', 'selectedVehicle')]
    });
  }
  async submitForm(data: any) {
    console.log("click submit form====")

    this.storage.setData({report_submit:true})
     
    this.tableData = [];
    this.vehicleTableData = [];
    this.employeeTableData = [];
    this.showTable = false;
    this.empTableShow = false;
    this.vehTableShow = false;
    this.loadershow=true;

     //this.loader.show();
     this.noDataFoundEnable = false;
    this.formData = data.formFilds;
    let obj = {}
    let vehRegno = [];
    let tempData = [];
    if (this.formData.selectedVehicle == 'ALL') {
      this.vehicles.map((veh: any) => {
        vehRegno.push(veh.vehRegNo);
      })
    }
    if ((this.formData.eDate.length == 0 || this.formData.eDate == undefined) && (this.formData.sDate.length == 0 || this.formData.sDate == undefined)) {
      let eDate = new Date();
      let sDate = new Date();
      obj = {
        startDate: sDate.setDate(sDate.getDate() - 1),
        endDate: eDate.setDate(eDate.getDate() - 1),
        vehRegNo: []
      }
      if (this.formData.selectedVehicle != undefined && this.formData.selectedVehicle.length > 0) {
        if (this.formData.selectedVehicle == 'ALL') {
          obj['vehRegNo'] = vehRegno;
        } else {
          obj['vehRegNo'] = [this.formData.selectedVehicle]
        }
      }
    } else {

      let eDate = new Date(this.formData.eDate);
      let sDate = new Date(this.formData.sDate);
      obj = {
        startDate: sDate.getTime(),
        endDate: eDate.getTime(),
        vehRegNo: [this.formData.selectedVehicle]
      }
      if (this.formData.selectedVehicle == 'ALL') {
        obj['vehRegNo'] = vehRegno;
      } else if (this.formData.selectedVehicle.length == 0 || this.formData.selectedVehicle == undefined) {
        obj['vehRegNo'] = [];
      }
    }

    try {
      const vehicle = this.formData.selectedVehicle;
      const startDate = new Date(this.formData.sDate + '');
      const endDate = new Date(new Date(this.formData.eDate + '').setHours(23, 59, 59));

      if (this.formData.selectedVehicle != undefined && this.formData.selectedVehicle.length > 0) {
        const arr: any = []
        let getDaysArray: any = function (start, end) {
          for (const dt: Date = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
            const date = new Date(dt);
            arr.push(date.getFullYear() + '/' + pad(date.getMonth() + 1) + '/' + pad(date.getDate()));
          }

          return arr;
        };
        const pad = (num) => {
          return num > 9 ? num : '0' + num;
        };

        const start = startDate.getFullYear() + '/' + pad(startDate.getMonth() + 1) + '/' + pad(startDate.getDate());
        const end = endDate.getFullYear() + '/' + pad(endDate.getMonth() + 1) + '/' + pad(endDate.getDate());

        let daylist: any = getDaysArray(new Date(start), new Date(end));

        let vehLen = [];
        if (!Array.isArray(this.formData.selectedVehicle)) vehLen = [this.formData.selectedVehicle];
        else vehLen = this.formData.selectedVehicle;
        if (this.formData.selectedVehicle == 'ALL') vehLen = vehRegno;

        daylist = [...new Set(daylist)];
        const checkCurrentDay = (date) => {
          var inputDate = new Date(date);
          // Get today's date
          var todaysDate = new Date();
          // setHours 
          if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) return true;
          else return false;
        };
        let vehRegString = '';
        for (let veh = 0; veh < vehLen.length; veh++) {
          vehRegString = vehRegString + ',' + vehLen[veh];
        }

        let vehRegEncryKey = await this.getVehicleEncryptRegNo(vehLen).catch((e) => { console.log('unable to veh reg no'); })
 
        for (let veh = 0; veh < vehLen.length; veh++) {
          
          let exlData = [];
          let pdata: any = [], excel = [];
          if (vehLen[veh] != undefined) {
            if (this.processedData[vehLen[veh]] == undefined) { this.processedData[vehLen[veh]] = {}; }
            for (let day = 0; day < daylist.length; day++) {
              this.checkDay = checkCurrentDay(daylist[day]);
              if (this.processedData[vehLen[veh]][daylist[day]] == undefined) this.processedData[vehLen[veh]][daylist[day]] = {};
              //this.loader.show()
              if (!this.checkDay) {
                console.log("!this.checkDay")
                if (vehRegEncryKey[vehLen[veh]] != null) {
                  const splitDate = daylist[day].split('/');
                  const date = splitDate[2] + splitDate[1] + splitDate[0].slice(-2);
                  const url = date + '/' + vehRegEncryKey[vehLen[veh]] + '.z';
                  let res;
                  await this.api.readS3Data(url).then((response: any) => {
                    res = response;
                  }).catch((e) => { });

                  let temp = await this.processData(res);
                  if (temp['data'][0] == undefined && temp['xldata'][0] == undefined) {
                    temp['data'] = [
                      {
                        "date": this.reverseDate(daylist[day]),
                        "dist": "---",
                        "timeDuration": "00:00:00",
                        "maxSpeed": "---",
                        "vehRegNo": vehLen[veh]
                      }
                    ]
                    tempData.push(temp['data'][0])
                    //this.noDataFoundEnable = true;
                  } else {
                    this.noDataFoundEnable = false;
                    await tempData.push(temp['data'][0])
                  }

                }
              }
              else {
                console.log("Enter Else")
                 //this.loader.show();
                let obj = {
                  vehRegNo: vehLen[veh],
                  date: new Date().setHours(0, 0, 0)
                };
                if (this.processedData[vehLen[veh]][daylist[day]] == undefined) { this.processedData[vehLen[veh]][daylist[day]] = {}; }
                // let getData = await this.comService.currentDayTrackingData(obj).catch((e) => { console.log('Unable to get current day data.'); });
                let getData;
                await this.comService.currentDayTrackingData(obj).then((res: any) => {
                  getData = res;
                }).catch((e) => { console.log(e, 'Unable to get current day data.'); });
                  console.log("CurrentdayTracking data===",getData)
                let temp = await this.processData(getData);
                if (temp['data'][0] == undefined && temp['xldata'][0] == undefined) {
                  temp['data'] = [
                    {
                      "date": this.com.timestampToDate(obj.date, 'DMY'),
                      "dist": "---",
                      "timeDuration": "00:00:00",
                      "maxSpeed": "---",
                      "vehRegNo": obj.vehRegNo
                    }
                  ]
                  tempData.push(temp['data'][0])
                  //this.noDataFoundEnable = true;
                } else {
                  //this.noDataFoundEnable = false;
                  await tempData.push(temp['data'][0])
                }
                // excel = [...excel,...tempData['xldata']];
                // this.loader.hide();
              }
              this.loader.show();
            }
          }
        }
      }
      await this.api.transportManagerReportTrip(obj).then(async (res: any) => {
        if (res.status === 'success' && res?.data?.length > 0) {
          this.tableData = res.data;
          this.processTableData(this.tableData);
          if (this.tableData.length > 0) {
            this.showTable = true;
            this.noDataFoundEnable = false;

            this.splitTableData(this.tableData)
             this.subject.broadcast({
              for: 'progress_handle',
              payload: true
            })
             this.storage.setData({report_submit:false})
            // this.mapTripDataWithVehicles(tempData);
          } else {
            this.noDataFoundEnable = true;
            this.showTable = false;
            this.subject.broadcast({
              for: 'progress_handle',
              payload: true
            })
            this.storage.setData({report_submit:false})
          }
        } else {
          this.handleNoData();
          this.subject.broadcast({
              for: 'progress_handle',
              payload: true
            })
          this.storage.setData({report_submit:false})
        }
      }).catch((err) => {
        console.log(err);
        //this.handleError();
      });
    } catch (error) {
      console.log(error);
      //this.handleError();
    }
  }

  processTableData(tableData: any[]): void {
    //this.loader.show(); //by rao
    tableData.forEach((trip: any) => {
      this.setRouteTypeDetails(trip);

      if (!['regular', 'openBooking', 'occasional'].includes(trip.routeType)) {
        if (trip.empInfo?.length > 0) {
          trip.empInfo.forEach((emp: any) => {
            this.isAssigned = emp.isAssigned ? true : false;
            emp.empTripStatus = this.formatTripStatus(emp.empTripStatus);
          });
        }
      } else {
        trip.tripStatus = 'Completed';
      }
    });
  }
  setRouteTypeDetails(trip: any): void {
    const routeTypeMap = {
      openBooking: { badge: 'OB', title: 'Open booking route' },
      regular: { badge: 'RE', title: 'Regular route' },
      occasional: { badge: 'OC', title: 'Occasional route' },
      roster: { badge: 'RO', title: 'Roster route' }
    };
    const routeType = trip?.routeType;
    if (routeTypeMap[routeType]) {
      trip.routeBadge = routeTypeMap[routeType].badge;
      trip.routeType_title = routeTypeMap[routeType].title;
    } else if (['roster', undefined].includes(trip.routeType) || trip.hasOwnProperty('rosterID')) {
      trip.routeBadge = routeTypeMap['roster'].badge;
      trip.routeType_title = routeTypeMap['roster'].title;
    }
    if (trip?.tripStatus == "Cancel") {
      trip.cancelBadge = "C";
    }
  }
  formatTripStatus(status: string): string {
    const statusMap: { [key: string]: string } = {
      noNeed: 'No need',
      noShow: 'No show',
      notUtilized: 'Not utilized'
    };
    return statusMap[status] || status;
  }
  mapTripDataWithVehicles(tempData: any[]): void {
    //this.loader.show(); //byrao
    this.tableData.forEach((item: any) => {
      item.tripDate = this.com.timestampToDate(item.tripDate, 'DMY');
      const isCurrentDay = this.checkCurrentDayFun(item.tripDate);

      tempData.forEach((veh: any) => {
        if (veh.vehRegNo.includes(item.vehRegNo) && veh.date.includes(item.tripDate)) {
          if (isCurrentDay) {
            item.deviceInfo = veh;
            item.currentDay = true;
          } else {
            item.vehTripInfo = veh;
            item.currentDay = false;
          }
        }
      });
      // }
    });
    this.splitTableData(this.tableData)
  }
  handleNoData(): void {
    this.tableData = [];
    this.noDataFoundEnable = true;
    this.showTable = false;
  }
  handleError(): void {
    this.tableData = [];
    this.noDataFoundEnable = true;
    this.showTable = false;
  }
  excelReportType(data: string) {
    this.report_type = '';
    this.report_type = data;
    if (this.report_type == 'vehicle') { this.tableHeaders = this.driverTabheaders }
    if (this.report_type == 'employee') { this.tableHeaders = this.emplHeaders }
  }
  splitTableData(data) {
    data.filter((item: any) => {
      if (item.hasOwnProperty('empInfo') && item?.empInfo.length > 0 && !['regular', 'openBooking', 'occasional'].includes(item?.routeType)) {
        console.log("Enter pop1");
        this.empTableShow = true;
        this.vehTableShow = true;
        item.tripDate = this.com.timestampToDate(item.tripDate, 'DMY');
        const isCurrentDay = this.checkCurrentDayFun(item.tripDate);
        if (isCurrentDay) {
          item.currentDay = true;
          item.deviceInfo = this.vehTripInfoFun(item);
        } else {
          item.currentDay = false;
          item.vehTripInfo = this.vehTripInfoFun(item);
        }

        this.employeeTableData.push(item)
        this.vehicleTableData.push(item)
      } else {
         console.log("Enter pop2",new Date(item.tripDate));
        item.tripDate = this.com.timestampToDate(item.tripDate, 'DMY');
        const isCurrentDay = this.checkCurrentDayFun(item.tripDate);
        if (isCurrentDay) {
          console.log("Checkcurrentday if",isCurrentDay);
          item.currentDay = true;
          item.deviceInfo = this.vehTripInfoFun(item);
        } else {    
            console.log("Checkcurrentday else",isCurrentDay); 
          item.currentDay = false;
          item.vehTripInfo = this.vehTripInfoFun(item);
        }
        this.vehTableShow = true;
        this.vehicleTableData.push(item)
      }
    });
    this.empTableShow = this.employeeTableData.length > 0;
    this.vehTableShow = this.vehicleTableData.length > 0;
  }


  vehTripInfoFun(item: any) {
     console.log("Enter vehTripInfoFun",item); 
    let start:any, end:any, distance;
    if (!['regular', 'openBooking', 'occasional'].includes(item?.routeType)) {
      if (item?.tripStatus == "Cancel") {
        start = "00:00:00"
        end = "00:00:00";
        distance = 0;
      } else {
        start = this.com.timestampToDate(item?.start?.time, 'H:M:S'),
          end = this.com.timestampToDate(item?.end?.time, 'H:M:S');
        distance = (item?.end?.value - item?.start?.value + '').split('-').join(' ');
      }
    } else {
      // start = this.com.timestampToDate(item?.tripStartTime, 'H:M:S'),
      //   end = this.com.timestampToDate(item?.tripEndTime, 'H:M:S');
      start=item?.tripStartTime;
      end=item?.tripEndTime;
      distance = item?.traveledKM;
    }
    
    const date = item?.tripDate;
    const timeDuration = this.com.timeDifference(start, end);
    const dist = distance;
    const maxSpeed = 0;
    const vehRegNo = item?.vehRegNo;

    return { date, timeDuration, dist, maxSpeed, vehRegNo }

  }


  async exportToExcel() {
    if (this.report_type == 'employee') {
      this.excelData = {};
      let data = [];
      let serialNo = 1;
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i];
        if (item && item['vehRegNo'] && item['vehRegNo'] != null) {
          try {

            for (let j = 0; j < item.empInfo?.length; j++) {
              let emp = item?.empInfo[j];
              let res = {
                value: [
                  serialNo++,
                  item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
                  item.tripDate ? item.tripDate : '---',
                  item.title && item.title ? this.com.convertTitleCase(item?.title) : '---',
                  item.transitMode ? this.com.convertTitleCase(item.transitMode) : '---',
                  emp.name ? this.com.convertTitleCase(emp.name) : '---',
                  emp.empRefID ? emp.empRefID : '---',
                  emp.gender ? this.com.convertTitleCase(emp.gender) : '---',
                  (emp.empTripStatus == 'boarded' || emp.empTripStatus == 'deboarded') ? 'Present' : (emp.empTripStatus == 'reschedule' ? 'Reschedule' : (emp?.empTripStatus == undefined && item?.tripStatus=="Cancel")?'Trip Cancelled':'Absent'),
                  emp.attenTime ? this.com.timestampToDate(emp.attenTime, 'DMY H:M A') : '---',
                  item.branchInfo.name ? this.com.convertTitleCase(item.branchInfo.name) : '---',
                  item.shiftTimeStr ? item.shiftTimeStr : '---',
                  item.tripStartTimeStr ? item.tripStartTimeStr : '---',
                  item.tripEndTimeStr ? item.tripEndTimeStr : '---',
                  item.tripsheetID ? item.tripsheetID : '---',
                  (item.driverInfo && item.driverInfo.name) ? item.driverInfo.name : '---',
                  (item.driverInfo && item.driverInfo.mobile) ? item.driverInfo.mobile : '---',
                  // (item.deviceInfo && item.deviceInfo.maxSpeed) ? item.deviceInfo.maxSpeed : '---',
                  // (item.deviceInfo && item.deviceInfo.dist) ? item.deviceInfo.dist : '---',
                  // (item.deviceInfo && item.deviceInfo.timeDuration) ? item.deviceInfo.timeDuration : '---',
                  item.acStatus ? item.acStatus : '---',
                  (item.vehInfo && item.vehInfo.vehType) ? item.vehInfo.vehType : '---',
                  (item.escortInfo && item.escortInfo.name) ? item.escortInfo.name : '---',
                  (item.escortInfo && item.escortInfo.mobile) ? item.escortInfo.mobile : '---',
                ],

                border: {
                  right: { style: 'thin' }, bottom: { style: 'thin' },
                },
              };
              data.push(res);
            }

          } catch (err) {
            console.log(err);
          }
        }
      }
      if (data.length > 0) {
        let rowCount = 2;
        let endCell = 'U';
        let customizedData = [];
        let titleRow = {
          value: ['Employee wise trip report'],
          font: {
            name: 'Corbel', family: 4, size: 16, bold: true,
            color: { argb: 'FFFFFFFF' },
          },
          mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
          alignment: {
            cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
          },
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: '966462AF' },
            bgColor: { argb: 'FFF' }
          },
        }
        customizedData.push(titleRow);
        rowCount = rowCount + 2;
        let subtitleRow = {
          value: [
            "Start Date       : " + this.comService.timestampToDate(new Date(this.formData.sDate).getTime(), 'DMY') + "\n" +
            "End Date         : " + this.comService.timestampToDate(new Date(this.formData.eDate).getTime(), 'DMY') + ""],
          font: { name: 'Corbel', family: 4, size: 12, },
          border: { right: { style: 'thin' } },
          mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        }

        customizedData.push(subtitleRow);

        rowCount = rowCount + 1;
        let headerRow =
        {
          value: ['S No', 'Reg no', 'Trip date', 'Shift name', 'Transit mode', 'Employee name', 'Employee ID', 'Gender', 'Attendance', 'Attendance time', 'Branch', 'Shift time', 'Trip start time', 'Trip end time', 'Trip sheet Id ', 'Driver name', 'Driver mobile', 'Trip type (Ac/Non Ac)', 'Vehicle type', 'Escort name', 'Escort Mobile'],
          font: { bold: true },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        }
        customizedData.push(headerRow);

        customizedData.push(...data);
        let excelSheetName = 'Employee wise report'

        if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

        this.excelData[excelSheetName] = {
          customizedData: customizedData,
          data: {
            columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 18 }, { colNo: 4, width: 18 }, { colNo: 5, width: 20 }, { colNo: 6, width: 20 }, { colNo: 7, width: 20 }, { colNo: 8, width: 20 }, { colNo: 9, width: 20 }, { colNo: 10, width: 30 }, { colNo: 11, width: 20 }, { colNo: 12, width: 20 }, { colNo: 13, width: 20 }, { colNo: 14, width: 20 }, { colNo: 15, width: 20 }, { colNo: 16, width: 20 }, { colNo: 17, width: 20 }, {
              colNo: 18
              , width: 20
            }, { colNo: 19, width: 22 }, { colNo: 20, width: 20 }, { colNo: 21, width: 20 }],
          }
        }
        this.downloadExlReport('employee report');
      }
    } else if (this.report_type == 'vehicle') {
      this.exportToExcelVehWise();
    }
  }

  async exportToExcelVehWise() {
    this.excelData = {};
    let data = [];
    let serialNo = 1;
    for (let i = 0; i < this.tableData.length; i++) {
      let item = this.tableData[i];
      if (item['vehRegNo'] != null) {
        try {
          let res = {
            value: [
              serialNo++,
              item.vehRegNo ? String(item.vehRegNo).toUpperCase() : '---',
              item.tripDate ? item.tripDate : '---',
              item.title && item.title ? this.com.convertTitleCase(item?.title) : '---',
              (item.driverInfo && item.driverInfo.name) ? item.driverInfo.name : '---',
              (item.driverInfo && item.driverInfo.mobile) ? item.driverInfo.mobile : '---',
              // (item.currentDay ? (item.deviceInfo && item.deviceInfo.maxSpeed ?
              //   item.deviceInfo.maxSpeed : (item.deviceInfo.maxSpeed == 0 ? item.deviceInfo.maxSpeed : '---')) :
              //   (item.vehTripInfo && item.vehTripInfo.maxSpeed && item.vehTripInfo.maxSpeed >= 0 ?
              //     item.vehTripInfo.maxSpeed :
              //     '---')
              // ),
              (item.currentDay ?
                (item.deviceInfo && item.deviceInfo.dist ?
                  item.deviceInfo.dist :
                  '---') :
                (item.vehTripInfo && item.vehTripInfo.dist ?
                  item.vehTripInfo.dist :
                  '---')
              ),
              (item.currentDay ? (item.deviceInfo && item.deviceInfo.timeDuration ?
                item.deviceInfo.timeDuration :
                '---') : (item.vehTripInfo && item.vehTripInfo.timeDuration ?
                  item.vehTripInfo.timeDuration :
                  '---')
              ),
              // (item.vehTripInfo && item.vehTripInfo.maxSpeed) ? item.vehTripInfo.maxSpeed : '---',
              // (item.vehTripInfo && item.vehTripInfo.dist) ? item.vehTripInfo.dist : '---',
              // (item.vehTripInfo && item.vehTripInfo.timeDuration) ? item.vehTripInfo.timeDuration : '---',
              item.acStatus ? item.acStatus : '---',
              item.vehInfo.vehType ? item.vehInfo.vehType : '---',
              item.transitMode ? this.com.convertTitleCase(item.transitMode) : '---',
              item?.branchInfo?.name ? this.com.convertTitleCase(item.branchInfo.name) : '---',
              item.shiftTimeStr ? item.shiftTimeStr : '---',
              item.tripStartTimeStr ? item.tripStartTimeStr : '---',
              item.tripEndTimeStr ? item.tripEndTimeStr : '---',
              (item?.vehChangeInfo && item?.vehChangeInfo?.oldVehicle) ? item?.vehChangeInfo?.oldVehicle : '---',
              (item?.vehChangeInfo && item?.vehChangeInfo?.reason) ? item?.vehChangeInfo?.reason : '---', 
              item?.tripStatus ? this.titleCasePipe.transform(item?.tripStatus) : '---'
            ],

            border: {
              right: { style: 'thin' }, bottom: { style: 'thin' },
            },
          }

          data.push(res);


        } catch (err) {
          console.log(err);
        }
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = 'R';
      let customizedData = [];
      let titleRow = {
        value: ['Vehicle wise trip report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);

      rowCount = rowCount + 2;
      let subtitleRow = {
        value: [
          "Start Date       : " + this.comService.timestampToDate(new Date(this.formData.sDate).getTime(), 'DMY') + "\n" +
          "End Date         : " + this.comService.timestampToDate(new Date(this.formData.eDate).getTime(), 'DMY') + ""],
        font: { name: 'Corbel', family: 4, size: 12, },
        border: { right: { style: 'thin' } },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Reg no', 'Trip date', 'Shift name', 'Driver name', 'Driver mobile', 'Distance travel (km)', 'Duration (HH:MM:SS)', 'Trip type (Ac/Non Ac)', 'Vehicle type', 'Transit mode', 'Branch', 'Shift time', 'Trip start time', 'Trip end time', 'Changed old vehicle', 'Reason for change', 'Trip status'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = 'Vehicle wise report'

      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 20 }, { colNo: 3, width: 20 }, { colNo: 4, width: 20 }, { colNo: 5, width: 20 }, { colNo: 6, width: 20, alignment: { horizontal: 'center', vertical: 'middle' } }, { colNo: 7, width: 20 }, { colNo: 8, width: 20 }, { colNo: 9, width: 20 }, { colNo: 10, width: 20 }, { colNo: 11, width: 20 }, { colNo: 12, width: 20 }, { colNo: 13, width: 20 }, { colNo: 14, width: 20 }, { colNo: 15, width: 20 }, { colNo: 16, width: 20 }, { colNo: 17, width: 20 }, { colNo: 18, width: 20 }],

          cellData: customizedData.map((item, index) => ({
            row: index + 2, // Assuming data starts from the second row
            col: 6, // 6th column
            value: item.sixthColumnValue, // Dynamically assigned value for the 6th column
            alignment: { horizontal: 'center', vertical: 'middle' } // Centering for the 6th column
          }))
        }
      }
      this.downloadExlReport('vehicle report');
    }
  }

  downloadExlReport(data: string) {
    const now = new Date();
  const formattedDate = now.toLocaleString('en-GB')
    .replace(/[/, ]/g, '-')
    .replace(/:/g, '-');
    this.excel.generateExcel(this.excelData, `MIS_${data}_${formattedDate}.xlsx`);
  }

  processData(data: any) {
    //this.loader.show(); //by rao
     console.log("processDatadata===",data)
    return new Promise((resolve, reject) => {
      // console.log('P1', data)
      try {
        //this.noDataFoundEnable = true;
        const procesedData: any = [];
        let timeDuration = 0;
        const speedLimit = 5;//((speed == undefined) || (speed == null) || (speed == '')) ? 5 : speed;
        const sortingData = {};
        if (data && data.length > 0) {
          data.map((item) => {
            // item.speed = 44;
            item.date = this.comService.timestampToDate(item.gpsts, 'DMY');
            if (item.gpsts != undefined) {
              sortingData[item.gpsts] = item;
            }
          });
        }
        else {
          //this.noDataFoundEnable = true;
        }
        let totalDis: any = 0;
        const objKeys = this.objectKeys(sortingData);
        let maxSpeed = 0;
        let time: any = '00:00:00';
        if (objKeys && objKeys.length) {

          const temp: any = []; let tempEx = [];
          for (let i = 0; i < objKeys.length; i++) {
            let prevKey = null, next = null, currentKey = objKeys[i], pre = null;
            if (i > 0) { prevKey = procesedData[procesedData.length - 1]; }
            if (objKeys[i + 1]) { next = objKeys[i + 1]; }
            let curdis = 0;
            if (i > 0) {
              pre = objKeys[i - 1];
              const lat1 = parseFloat(sortingData[currentKey].lat);
              const lat2 = parseFloat(sortingData[pre].lat);
              const lng1 = parseFloat(sortingData[currentKey].lng);
              const lng2 = parseFloat(sortingData[pre].lng);
              if ((lat1 == lat2) && (lng1 == lng2)) { curdis = 0; } else {
                const radlat1 = Math.PI * lat1 / 180.0;
                const radlat2 = Math.PI * lat2 / 180.0;
                const theta = lng1 - lng2;
                const radtheta = Math.PI * theta / 180.0;
                let dist: any = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                  dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180 / Math.PI;
                dist = dist * 60 * 1.1515;
                dist = (dist * 1.609344);
                curdis = parseFloat(dist);
              }
              if (sortingData[pre].spd && sortingData[currentKey].spd) {
                if (Number(sortingData[pre].spd) > 5 && Number(sortingData[currentKey].spd) > 5) {
                  let timeValue = this.comService.timeDiff(sortingData[pre].gpsts, sortingData[currentKey].gpsts);
                  timeDuration = timeValue.seconds ? (timeDuration + timeValue.seconds) : (timeDuration + 0);
                  let seconds = Math.floor(timeDuration);
                  let minute = Math.floor(seconds / 60);
                  seconds = seconds % 60;
                  let hour = Math.floor(minute / 60);
                  minute = minute % 60;
                  time = (('' + hour).length == 1 ? '0' + hour : hour) + ':' + (('' + minute).length == 1 ? '0' + minute : minute) + ':' + (('' + seconds).length == 1 ? '0' + seconds : seconds);
                }
              }
            }
            totalDis = parseFloat(totalDis) + curdis;

            if (Number(sortingData[currentKey].spd) > maxSpeed) maxSpeed = +sortingData[currentKey].spd;
            let resValue = {
              date: sortingData[currentKey].date,
              dist: totalDis.toFixed(2),
              timeDuration: time,
              maxSpeed: maxSpeed,
              vehRegNo: sortingData[currentKey].reg
            }

            if ((objKeys.length - 1) == i) {
              const rowVal = {
                value: [sortingData[currentKey].date, time, totalDis.toFixed(2), maxSpeed]
              };
              this.tableData.push(resValue);
              tempEx.push(rowVal);
              temp.push(resValue);
              const tdata = JSON.parse(JSON.stringify(resValue));
              procesedData.push(tdata);
              //this.loader.show(); //by rao

              resolve({ data: procesedData, xldata: tempEx });
            }
          }
        } else {
          resolve({ data: [], xldata: [] });
        }

      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  }
  getSerialNumber(outerIndex: number, innerIndex: number): number {
    let startIndex = 1; // Start counting from 1
    let count = 0;

    for (let k = 0; k < outerIndex; k++) {
      count += this.tableData[k].empInfo.length;
    }

    return count + innerIndex + startIndex;
  }
  checkCurrentDayFun = (date) => {
    const targetDateString = date;
    const [day, month, year] = targetDateString.split('/');
    const targetDate = new Date(Number(year), Number(month) - 1, Number(day));
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return currentDate.getTime() == targetDate.getTime();
  }

  reverseDate(dateStr) {
    // Split the date string by '/'
    let dateParts = dateStr.split('/');
    if (dateParts[0]?.length > 3) {
      let reversedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
      return reversedDate;
    }
  }
};